/** Path-aware section themes for browse hubs + matching search bar. */

export const VERTICAL_THEME = {
  mint: 'mint',
  curated: 'curated',
  luxury: 'luxury',
  designers: 'designers',
  boutiques: 'boutiques',
  wedding: 'wedding',
};

const matchesPath = (pathname, base) =>
  pathname === base || pathname.startsWith(`${base}/`);

export function getVerticalThemeFromPath(pathname = '') {
  if (
    matchesPath(pathname, '/pre-owned-items') ||
    matchesPath(pathname, '/hobbies-finds') ||
    matchesPath(pathname, '/items') ||
    matchesPath(pathname, '/artists') ||
    matchesPath(pathname, '/artist-items') ||
    matchesPath(pathname, '/admin')
  ) {
    return VERTICAL_THEME.curated;
  }
  if (
    matchesPath(pathname, '/luxury') ||
    matchesPath(pathname, '/list-luxury-piece')
  ) {
    return VERTICAL_THEME.luxury;
  }
  if (
    matchesPath(pathname, '/designers') ||
    matchesPath(pathname, '/designer-items')
  ) {
    return VERTICAL_THEME.designers;
  }
  if (
    matchesPath(pathname, '/boutiques') ||
    matchesPath(pathname, '/boutique-items') ||
    matchesPath(pathname, '/local-shops')
  ) {
    return VERTICAL_THEME.boutiques;
  }
  if (matchesPath(pathname, '/wedding-essentials')) {
    return VERTICAL_THEME.wedding;
  }
  return VERTICAL_THEME.mint;
}

export const isDarkVerticalSearchTheme = () => false;
